/*!
 *
 *  switch-fontsize.js
 *
 */


require('jquery.cookie');

var setting, defo = {
	cookieName: 'font-size',
	btn: '.font-switch-btn',
	target: 'html'
};

var setSize = function( btn, size ){
	if( size === 'large' ){
		$( setting.target ).addClass('sw-FontLarge');
	}else{
		$( setting.target ).removeClass('sw-FontLarge');
	};
	$( setting.btn + '-current' ).removeClass( setting.class + '-current' );
	$( btn ).addClass( setting.class + '-current' );
	$.removeCookie( setting.cookieName );
	$.cookie( setting.cookieName, size, { expires: 7, path: '/'});
};

module.exports = function(options){

	setting = $.extend({}, defo, options);
	setting.class = setting.btn.replace(/\./, '');

	var cookie = $.cookie(setting.cookieName);
	var current;

	if( cookie ){
		current = cookie;
	}else{
		current = 'default';
		$.cookie( setting.cookieName, 'default', { expires: 7, path: '/'});
	};

	$( setting.btn ).each(function(){
		if( $(this).val() === current ){
			setSize(this, current);
		};
	});

	$( setting.btn ).on('tap', function(e){
		e.preventDefault();
		if( !$(this).is( setting.btn + '-current') ){
			setSize( this, $(this).val() );
		};
	})
	$( setting.btn ).on('keydown', function(e){
		if( e.keyCode === 13 ) {
			e.preventDefault();
			if( !$(this).is( setting.btn + '-current') ){
				setSize( this, $(this).val() );
			};
		};
	});
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/switch-fontsize.js
// module id = 22
// module chunks = 0